'use strict';

angular.module('studies')
    .controller('StudyCreationAccessController', ['AccountManager', 'StudiesManager', function(AccountManager, StudiesManager) {
        var vm = this;

        vm.ready = false;

        vm.$onInit = function() {
            return AccountManager.init()
                .then(function() {
                    vm.canCreateStudies = AccountManager.hasPermission('create studies');

                    return StudiesManager.init();
                })
                .then(function() {
                    var loggedUser = AccountManager.getLoggedUser();

                    var numStudies = StudiesManager.countUserCreatedStudies(loggedUser.id);
                    var maxStudies = loggedUser.maxStudies;

                    vm.maxReached = maxStudies && numStudies >= maxStudies;

                    vm.ready = true;
                });
        };
    }]);
